import WebexLogo from '@/assets/images/webex.svg';

const WebexIcon = ({ size = 25 }) => (
    <img
        src={WebexLogo}
        alt="Webex Logo"
        style={{ height: size, width: size }}
    />
);

export default WebexIcon;
